export default __webpack_public_path__ + "static/image-satellite-e6305d1daa12e7cc701d364fbe755f0b.png";